import { useState, useCallback } from 'react';

import { FormState } from '../presentation/features/variety-planner/types';

export const useFormState = () => {
  const [formState, setFormState] = useState<FormState>({});

  const updateFormValue = useCallback(
    (questionId: string, value: string | string[]) => {
      setFormState((prev) => ({
        ...prev,
        [questionId]: value,
      }));
    },
    []
  );

  const setNewFormState = useCallback((newFormState: FormState) => {
    setFormState(newFormState);
  }, []);

  const resetForm = useCallback(() => {
    setFormState({});
  }, []);

  return {
    formState,
    updateFormValue,
    setNewFormState,
    resetForm,
  };
};
